import { useState } from "react";
import { DEEP_DIVES, CATEGORY_META } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function DeepDives() {
  const [openId, setOpenId] = useState<string | null>(DEEP_DIVES[0].id);

  return (
    <section id="focus" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          align="center"
          eyebrow="深度盘点"
          title="不止吃瓜，也把来龙去脉讲清楚"
          desc="针对热度靠前的瓜田，编辑组会额外写一份深度盘点，把现象背后的套路、结构与背景一次说透，给你比零散切片更完整的信息量。"
        />

        <div className="mx-auto mt-10 max-w-4xl space-y-4">
          {DEEP_DIVES.map((d, idx) => {
            const meta = CATEGORY_META[d.category];
            const isOpen = openId === d.id;
            return (
              <article
                key={d.id}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors"
              >
                <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-start md:p-6">
                  <span className="font-heading text-4xl font-black leading-none text-accent-500">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-bold text-secondary-800">
                        <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
                        {d.tag} · {meta.name}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                      {d.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{d.summary}</p>

                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : d.id)}
                      aria-expanded={isOpen}
                      className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100 px-5 py-2 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-200"
                    >
                      {isOpen ? "收起" : "展开阅读"}
                      <i className={`${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base`} />
                    </button>
                  </div>
                </div>

                {isOpen && (
                  <div className="border-t border-background-200 bg-background-50 px-5 py-6 md:px-8 md:py-8">
                    <div className="space-y-4 text-sm leading-7 text-foreground-700">
                      {d.body.map((p, i) => (
                        <p key={i}>{p}</p>
                      ))}
                    </div>
                    <p className="mt-6 border-l-2 border-accent-400 pl-3 text-xs text-foreground-400">
                      本文为今日瓜报编辑部整理的公开信息复盘，仅供信息参考与讨论。
                    </p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}